/** Main reality check component */


<template>
    <div>
        <div class="sidebar-container">
            <div class="sidebar-cover"></div>  <!-- grey cover -->
            <sidebar/>
        </div>

        <div class="mobile-info-block">
<!--            <div class="mobile-mcs-logo">-->
<!--                <a href="https://mcsuk.org">-->
<!--                    <svg aria-hidden="true" focusable="false">-->
<!--                        <use href="#mcs-logo"></use>-->
<!--                    </svg>-->
<!--                </a>-->
<!--            </div>-->
<!--            <div class="mobile-wt-logo">-->
<!--                <a class="" target="_blank" href="https://www.wildlifetrusts.org/">-->
<!--                    <img class="" src="/static/img/TWT_LOGO_PRIMARY_COLOUR.SVG.svg" alt="The Wildlife Trusts">-->
<!--                </a>-->
<!--            </div>-->
<!--            <div class="mobile-blue-logo">-->
<!--                <a target="_blank" href="https://www.bluemarinefoundation.com">-->
<!--                    <img src="/static/img/BMF_Logo_CMYK_Blue.svg" alt="Blue Marine Foundation">-->
<!--                </a>-->
<!--            </div>-->
<!--            <div style="flex-basis: 100%; height: 0; display: flex"></div>-->
            <h1>MPA Reality Check</h1>
        </div>

        <main-map/>
    </div>
</template>


<script>
import MainMap from "./main-map.vue";
import Sidebar from "./sidebar.vue";


export default {
    name: "reality-check",
    components: {
        MainMap, Sidebar
    },
    props: {},
    data: function () {
        return {}
    },
    methods: {},
    computed: {},
    watch: {},
    mounted: function () {
    }
}
</script>


<style lang="scss">
    @import "../../styles/variables.scss";

    .sidebar-container {
        position: absolute;
        top: 0; bottom: 0; left: 0;
        width: 300px;
        max-height: 100%;
        overflow-y: scroll;
        scrollbar-width: thin;
        background-color: $light-blue-background;  // so top menu doesn't bleed though
        z-index: 5001;

        & > .sidebar-cover {
            position: fixed;
            height: 100%; width: 300px;
            pointer-events: none;
            background-color: rgba(35, 35, 50, .15);

            @media #{$breakpoint-lg-max} {
                width: 260px;
            }
        }

        @media #{$breakpoint-int} {
            display: none;
        }

        @media #{$breakpoint-lg-max} {
            width: 260px;
        }
    }

    .mobile-info-block {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        @media #{$breakpoint-int-min} {
            display: none;
        }

        //border: 1px solid red;
        z-index: 5001;
        position: absolute;
        top: -10px; left: 10px;
        width: 280px;

        .mobile-mcs-logo {
            margin-right: 10px;

            svg {
                fill: #05516E;  // $main-text-color;
                width: 140px;
                height: 56px;
            }
        }

        .mobile-wt-logo {
            img {
                height: 55px;
                //border: 1px solid green;
                margin-top: 7px;
            }
        }

        .mobile-blue-logo {
            img {
                height: 55px;
                margin-top: 7px;
            }
        }

        h1 {
            width: 100%;
            font-size: 120%;
            //text-align: center;
            margin: 15px 0 0 0;
            color: #05516E;
        }
    }
</style>